<template>
	<a class="mastercard-callout ordersummary-border-box" href="/mastercard">
		<div class="mastercard-callout__content">
			<picture class="mastercard-callout__picture hide-mobile">
				<source srcset="/assets/images/credit-cards/blain-card-pdp.webp" type="image/webp" />
				<source srcset="/assets/images/credit-cards/blain-card-pdp.jpg" type="image/jpeg" />
				<img class="mastercard-callout__thumbnail" alt="" src="/assets/images/credit-cards/blain-card-pdp.jpg" />
			</picture>

			<div class="mastercard-callout__text-wrapper">
				<p class="mastercard-callout__title">
					<picture class="mastercard-callout__picture show-mobile">
						<source srcset="/assets/images/credit-cards/blain-card-pdp.webp" type="image/webp" />
						<source srcset="/assets/images/credit-cards/blain-card-pdp.jpg" type="image/jpeg" />
						<img class="mastercard-callout__thumbnail" alt="" src="/assets/images/credit-cards/blain-card-pdp.jpg" />
					</picture>
					Buy Now. Pay Over Time.
				</p>
				<p class="mastercard-callout__description">Get <strong>0% intro APR financing<sup>2</sup></strong> for <strong>12 billing cycles</strong> on purchases of <strong>$500 or more at Blain's</strong> with a Blain's Farm &amp; Fleet Rewards Mastercard®</p>
			</div>
		</div>
		<icon name="chevron-right" class="mastercard-callout__chevron" />
	</a>
</template>

<script>
import Icon from '../../components/Icon.vue';
export default {
	name: 'ProductMastercardCallout',
	components: {
		Icon
	}
};
</script>

<style lang="less" scoped>
 @import "../../../less/_mixins";
.mastercard-callout {
	display: flex;
	flex-direction: row;
	padding: 10px;
	justify-content: space-between;
	gap: 10px;
	align-items: center;
	text-decoration: none;

	.tablet-and-up-styles({
		padding: 10px 15px;
	});

	&__picture {
		width: 39px;
		height: 25px;

		.tablet-and-up-styles({
			width: 60px;
			height: 39px;
		})
	}

	&__thumbnail {
		width: 39px;
		height: 25px;

		.tablet-and-up-styles({
			width: 60px;
			height: 39px;
		})
	}

	&__content {
		display: flex;
		gap: 14px;
		align-items: center;
	}

	&__text-wrapper {
		display: flex;
		flex-direction: column;
		text-align: left;
		gap: 8px;
		max-width: 500px;

		.tablet-and-up-styles({
			gap: 4px;
		});
	}

	&__title {
		font-weight: bold;
		line-height: 1.25;
		font-size: 1rem;
		margin: 0;
		color: black;
		display: flex;
		gap: 9px;
		align-items: flex-end;
	}

	&__description {
		font-size: 0.75rem;
		line-height: 1.25;
		color: #191B26;
		margin: 0;

		.tablet-and-up-styles({
			font-size: 0.875;
		});

		strong {
			font-weight: 500;
		}
	}

	&__chevron{
		color: @BB;
		font-size: 20px;
		margin-left: 10px;
	}

	sup {
		vertical-align: super;
		font-size: 0.4rem;

		.tablet-and-up-styles({
			font-size: 0.5rem;
		})
	}
}
</style>